<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
    absolute
  >
    <v-img
      :src="image"
      height="100%"
    >
      <v-layout
        class="fill-height"
        tag="v-list"
        column
      >
        <v-list-tile avatar>
          <v-list-tile-avatar
            color="white"
          >
            <v-img
              :src="logo"
              height="64"
              contain
            />
          </v-list-tile-avatar>
          <v-list-tile-title class="title">
            {{ user.name }}
            <p class="grade">
              <span v-if="user.type == 'affiliate' && user.affiliate">
                Level {{ user.affiliate.level }}
              </span>
              <span v-else>
                Administrator
              </span>
            </p>
          </v-list-tile-title>
        </v-list-tile>
        <v-divider/>
        <v-list-tile
          v-if="responsive"
        >
          <v-text-field
            class="purple-input search-input"
            label="Search..."
            color="purple"
          />
        </v-list-tile>
        <v-list-tile
          v-for="(link, i) in (user&&user.type==='affiliate'?affiliateLinks:adminLinks)"
          :key="i"
          :to="link.to"
          :active-class="color"
          avatar
          class="v-list-item"
        >
          <v-list-tile-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-title
            v-text="link.text"
          />
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'

export default {
  data: () => ({
    logo: require('@/assets/img/logo.png'),
    adminLinks: [
      // {
      //   to: '/dashboard/dashboard',
      //   icon: 'mdi-clipboard-outline',
      //   text: 'Dashboard'
      // },
      // {
      //   to: '/dashboard/user-profile',
      //   icon: 'mdi-account',
      //   text: 'User Profile'
      // },
      // {
      //   to: '/dashboard/affiliates',
      //   icon: 'mdi-account-multiple',
      //   text: 'Affiliates'
      // },
      // {
      //   to: '/dashboard/clients',
      //   icon: 'mdi-account-group',
      //   text: 'Clients'
      // },
      // {
      //   to: '/dashboard/categories',
      //   icon: 'mdi-view-list',
      //   text: 'Categories'
      // },
      {
        to: '/dashboard/stores',
        icon: 'mdi-view-list',
        text: 'Stores'
      },
      {
        to: '/dashboard/products',
        icon: 'mdi-view-list',
        text: 'Products'
      }
      // {
      //   to: '/dashboard/services',
      //   icon: 'mdi-table-edit',
      //   text: 'Services'
      // },
      // {
      //   to: '/dashboard/subscriptions',
      //   icon: 'mdi-table-edit',
      //   text: 'Subscriptions'
      // }
      // {
      //   to: '/dashboard/typography',
      //   icon: 'mdi-format-font',
      //   text: 'Typography'
      // },
      // {
      //   to: '/dashboard/icons',
      //   icon: 'mdi-chart-bubble',
      //   text: 'Icons'
      // },
      // {
      //   to: '/dashboard/maps',
      //   icon: 'mdi-map-marker',
      //   text: 'Maps'
      // },
      // {
      //   to: '/dashboard/notifications',
      //   icon: 'mdi-bell',
      //   text: 'Notifications'
      // }
    ],
    affiliateLinks: [
      {
        to: '/dashboard/affiliate-dashboard',
        icon: 'mdi-account',
        text: 'Dashboard'
      },
      {
        to: '/dashboard/affiliate-profile',
        icon: 'mdi-account',
        text: 'User Profile'
      },
      {
        to: '/dashboard/clients/subscriptions',
        icon: 'mdi-account',
        text: 'My Clients'
      },
      {
        to: '/dashboard/affiliates/services',
        icon: 'mdi-table-edit',
        text: 'Services'
      }
      // {
      //   to: '/dashboard/table-list',
      //   icon: 'mdi-clipboard-outline',
      //   text: 'Table List'
      // },
      // {
      //   to: '/dashboard/notifications',
      //   icon: 'mdi-bell',
      //   text: 'Notifications'
      // }
    ],
    responsive: false,
    user: JSON.parse(localStorage.getItem('userInfo'))
  }),
  computed: {
    ...mapState('app', ['image', 'color']),
    inputValue: {
      get () {
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    }
  },
  mounted () {
    this.onResponsiveInverted()
    window.addEventListener('resize', this.onResponsiveInverted)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onResponsiveInverted)
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    onResponsiveInverted () {
      if (window.innerWidth < 991) {
        this.responsive = true
      } else {
        this.responsive = false
      }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .grade {
      margin: 4px 0 0 0;
      color: #999;
    }
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 12px;
      width: 40px;
      height: 40px;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }
  }
</style>
